import { Skeleton } from "@mui/material";
import { BlockCard, SegmentedPillsSkeleton } from "../primitives";
import styles from "./style.module.scss";

interface TopBooksBlockSkeletonProps {
  count?: number;
  className?: string;
}

function TopBooksBlockSkeleton({
  count = 5,
  className,
}: TopBooksBlockSkeletonProps) {
  return (
    <BlockCard
      flush
      /* 86 x 28 is what "Top books" actually occupies at .title's 18px/28px.
         Overshooting wraps the header onto a second line, which eats a row
         off the list below. maxWidth keeps it shrinking with the card. */
      title={
        <Skeleton
          variant="text"
          width={86}
          height={28}
          sx={{ maxWidth: "100%" }}
        />
      }
      className={className}
      actions={<SegmentedPillsSkeleton count={2} width={76} shape="box" />}
    >
      <div className={styles.list}>
        {Array.from({ length: count }).map((_, index) => (
          <div key={index} className={styles.row}>
            <Skeleton variant="text" width={14} height={18} />
            <Skeleton
              variant="rounded"
              width={30}
              height={42}
              sx={{ borderRadius: "5px" }}
            />
            <div className={styles.meta}>
              <Skeleton variant="text" width="72%" height={20} />
              <Skeleton variant="text" width="56%" height={16} />
              <Skeleton variant="text" width="40%" height={16} />
            </div>
            {/* No delta placeholder: these rows carry no trend, so DeltaBadge
                renders nothing and reserving a pill would push the row past
                its fixed height. */}
            <div className={styles.figures}>
              <Skeleton variant="text" width={48} height={20} />
              <Skeleton variant="text" width={34} height={14} />
            </div>
          </div>
        ))}
      </div>
    </BlockCard>
  );
}

export default TopBooksBlockSkeleton;
